import httpClient from './httpClient';
import type { OwnerDashboard } from '@/types/analytics';

export interface SalesTrendPoint {
  month: string; // 'YYYY-MM'
  revenue: number;
}

export interface RecentOperation {
  id: string;
  entryDate: string;
  debitAccount: string;
  creditAccount: string;
  amount: number;
  description?: string | null;
  documentId?: string | null;
  documentTypeName?: string | null;
  documentNumber?: string | null;
}

export const analyticsApi = {
  async getOwnerDashboard(): Promise<OwnerDashboard> {
    const acqRes = await httpClient.get<OwnerDashboard>('/analytics/owner-dashboard');
    return acqRes.data;
  },

  async getSalesTrend(acqMonths = 6): Promise<SalesTrendPoint[]> {
    const acqRes = await httpClient.get<SalesTrendPoint[]>('/analytics/sales-trend', {
      params: { months: acqMonths },
    });
    return acqRes.data;
  },

  async getRecentOperations(acqLimit = 10): Promise<RecentOperation[]> {
    const acqRes = await httpClient.get<RecentOperation[]>('/analytics/recent-operations', {
      params: { limit: acqLimit },
    });
    return acqRes.data;
  },
};
